const shadowMutationObserver = (element, callback, options = {
    childList: true,
    subtree: true,
}) => {
    var _a;
    const observer = new MutationObserver(callback);
    let el = element.getRootNode();
    while (el) {
        observer.observe(el, options);
        el = (_a = el.host) === null || _a === void 0 ? void 0 : _a.getRootNode();
    }
    return observer;
};

export { shadowMutationObserver };
